<template>
  <div>
    <section class="section">
      <form @submit.prevent="validateBeforeSubmit">
        <div class="container" style="padding-top:50px;">
          <div class="columns is-multiline">
            <div class="column is-6">
              <!----------- ad & active ---------------------------------->
              <div class="box">
                <div class="field">
                  <input
                    class="is-checkradio is-circle"
                    id="active"
                    type="checkbox"
                    name="active"
                    v-model="n.active"
                  >
                  <label for="active">Aktiviert</label>
                  <input
                    class="is-checkradio is-circle"
                    id="ad"
                    type="checkbox"
                    name="ad"
                    v-model="n.ad"
                  >
                  <label for="ad">Bezahlte Anzeige</label>
                </div>
              </div>

              <div class="box">
                <!----------- type ---------------------------------->
                <div class="field">
                  <label class="label">Art</label>
                  <div class="control has-icons-right">
                    <select
                      class="select is-fullwidth"
                      v-model="n.type"
                      name="type"
                      v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('type') }"
                    >
                      <option value="1">Allgemein</option>
                      <option value="2">Veranstaltung</option>
                      <option value="3">Ausflugsziel</option>
                      <option value="4">Kulinarium</option>
                      <option value="5">Unterkunft</option>
                    </select>
                    <span class="icon is-right" v-show="errors.has('type')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span v-show="errors.has('type')" class="help is-danger">{{ isEmpty }}</span>
                  </div>
                </div>

                <!----------- date ---------------------------------->
                <div class="field" v-if="n.type==2">
                  <label class="label">Datum</label>
                  <div class="control has-icons-right is-fullwidth">
                    <flat-pickr
                      v-model="n.date"
                      :config="dateConfig"
                      class="input"
                      placeholder="Datum wählen"
                      v-validate="'required'"
                      name="date"
                    ></flat-pickr>
                    <span class="icon is-right" v-show="errors.has('date')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span v-show="errors.has('date')" class="help is-danger">{{ isEmpty }}</span>
                  </div>
                </div>
              </div>

              <!----------- SERP Preview ---------------------------------->
              <div class="box">
                <div
                  style="text-decoration: none; color: #1a0dab; font-size: 21px; font-family: arial,sans-serif; height: 35px; overflow: hidden;"
                >
                  <span v-if="n.seo.title">{{ n.seo.title }} - Urlaub im Waldviertel</span>
                  <span v-else>Google SERP Preview: Geben Sie einen Meta Title an</span>
                </div>

                <div
                  style="color: #006621; font-size: 16px; font-family: arial,sans-serif; line-height: 16px; height: 22px; overflow: hidden;"
                >
                  <span v-if="n.seo.niceUrl">{{ n.seo.niceUrl }}</span>
                  <span v-else>www.urlaubimwaldviertel.at</span>
                </div>

                <div
                  style="font-family: arial,sans-serif; line-height: 18px; font-size: 16px; max-height: 54px; overflow: hidden;"
                >
                  <span v-if="n.seo.description">{{ n.seo.description }}</span>
                  <span
                    v-else
                  >Lorem ipsum dolor sit amet, consectetur adipisicing elit. Fugiat quibusdam, eos eveniet, earum itaque eius, ipsum voluptas, voluptates similique rem nobis dolor.</span>
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="box card-equal-height">
                <h2 class="title">SEO</h2>

                <!----------- title ---------------------------------->
                <div class="field">
                  <label class="label">Meta title (50 Zeichen)*
                    <a href="https://moz.com/learn/seo/title-tag" target="_blank" class="icon">
                      <i class="fa fa-question-circle-o"></i>
                    </a>
                  </label>
                  <div class="control has-icons-right">
                    <input
                      maxlength="50"
                      class="input"
                      type="text"
                      v-validate="'required'"
                      :class="{'input': true, 'is-danger': errors.has('title') }"
                      v-model="n.seo.title"
                      v-on:keyup="sanitizeTitle"
                      name="title"
                    >
                    <span class="icon is-right" v-show="errors.has('title')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span v-show="errors.has('title')" class="help is-danger">{{ isEmpty }}</span>
                  </div>
                </div>

                <!----------- niceUrl ---------------------------------->
                <div class="field">
                  <div class="control">
                    <span class="icon">
                      <i class="fa fa-chain"></i>
                    </span>
                    <span style="color: blue;">/details/{{ n.seo.niceUrl }}</span>
                  </div>
                </div>

                <!----------- description ---------------------------------->
                <div class="field">
                  <label class="label">Meta description (50-300 Zeichen)*
                    <a
                      href="https://moz.com/learn/seo/meta-description"
                      target="_blank"
                      class="icon"
                    >
                      <i class="fa fa-question-circle-o"></i>
                    </a>
                  </label>
                  <div class="control">
                    <textarea
                      maxlength="300"
                      rows="4"
                      class="textarea"
                      name="description"
                      v-model="n.seo.description"
                    ></textarea>
                  </div>
                </div>

                <!----------- canonical ---------------------------------->
                <div class="field">
                  <label class="label">Canonical tag
                    <a
                      href="https://moz.com/learn/seo/canonicalization"
                      target="_blank"
                      class="icon"
                    >
                      <i class="fa fa-question-circle-o"></i>
                    </a>
                  </label>
                  <div class="control has-icons-right">
                    <input
                      class="input"
                      v-model="n.seo.can"
                      name="canonical"
                      v-validate="'url:require_protocol'"
                      placeholder="URL mit https://"
                    >
                    <span class="icon is-right" v-show="errors.has('canonical')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span v-show="errors.has('canonical')" class="help is-danger">URL ungültig</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-12">
              <!----------- headline ---------------------------------->
              <div class="field">
                <label class="label">Überschrift*</label>
                <div class="control has-icons-right">
                  <input
                    maxlength="500"
                    class="input"
                    type="text"
                    v-validate="'required'"
                    :class="{'input': true, 'is-danger': errors.has('headline') }"
                    v-model="n.headline"
                    name="headline"
                  >
                  <span class="icon is-right" v-show="errors.has('headline')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span v-show="errors.has('headline')" class="help is-danger">{{ isEmpty }}</span>
                </div>
              </div>

              <!----------- subtitle ---------------------------------->
              <div class="field">
                <label class="label">Untertitel</label>
                <div class="control">
                  <input
                    maxlength="500"
                    class="input"
                    type="text"
                    v-model="n.subtitle"
                    name="subtitle"
                  >
                </div>
              </div>

              <!----------- tags ---------------------------------->
              <div class="field">
                <label class="label">Tags*</label>
                <div class="control">
                  <div class="field is-grouped is-grouped-multiline">
                    <div v-for="(i, index) in allTags" :key="index" class="control">
                      <div class="tags has-addons">
                        <span
                          @click="filterContentBy(i)"
                          class="tag is-rounded is-medium cursor"
                          :class="[ {'tag_reset' : (n.tags.indexOf(i) === -1)}, 'tag_' + i ]"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!----------- text ---------------------------------->
              <div class="field">
                <label class="label">Text*</label>
                <div class="control">
                  <vue-editor v-model="n.text" :editorToolbar="customToolbar"></vue-editor>
                </div>
              </div>
            </div>

            <div class="column is-4">
              <div class="box card-equal-height">
                <div class="field">
                  <label class="label">Adresse finden</label>
                  <div class="control">
                    <GmapAutocomplete @place_changed="setPlace" class="input" placeholder="Adresse"></GmapAutocomplete>
                  </div>
                </div>

                <gmap-map
                  :center="center"
                  :zoom="8"
                  style="width: 100%; height: 400px; margin-bottom:20px;"
                  :options="{ disableDefaultUI: true, zoomControl: true }"
                >
                  <!-- load current location marker -->
                  <gmap-marker
                    v-if="n.address.position.lat!=undefined && n.address.position.lng!=undefined"
                    :position="n.address.position"
                    :draggable="true"
                    @dragend="getCoordinates($event)"
                  ></gmap-marker>
                </gmap-map>

                <!----------- lng ---------------------------------->
                <div class="field">
                  <label class="label">Longitude*</label>
                  <div class="control has-icons-right">
                    <input
                      class="input"
                      type="text"
                      v-model.number="n.address.position.lng"
                      name="lng"
                      v-validate="'required'"
                    >
                    <span class="icon is-right" v-show="errors.has('lng')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span v-show="errors.has('lng')" class="help is-danger">{{ isEmpty }}</span>
                  </div>
                </div>

                <!----------- lat ---------------------------------->
                <div class="field">
                  <label class="label">Latitude*</label>
                  <div class="control has-icons-right">
                    <input
                      class="input"
                      type="text"
                      v-model.number="n.address.position.lat"
                      name="lat"
                      v-validate="'required'"
                    >
                    <span class="icon is-right" v-show="errors.has('lat')">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span v-show="errors.has('lat')" class="help is-danger">{{ isEmpty }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-8">
              <div class="box card-equal-height">
                <!----------- name ---------------------------------->
                <div class="field">
                  <label class="label">Name*</label>
                  <div class="control">
                    <input class="input" type="text" v-model="n.address.name" name="name">
                  </div>
                </div>

                <!----------- street ---------------------------------->
                <div class="field">
                  <label class="label">Straße</label>
                  <div class="control">
                    <input class="input" type="text" v-model="n.address.street" name="street">
                  </div>
                </div>

                <!----------- zip ---------------------------------->
                <div class="field">
                  <label class="label">Postleitzahl</label>
                  <div class="control">
                    <input class="input" type="text" v-model="n.address.zip" name="zip">
                  </div>
                </div>

                <!----------- city ---------------------------------->
                <div class="field">
                  <label class="label">Stadt</label>
                  <div class="control">
                    <input class="input" type="text" v-model="n.address.city" name="city">
                  </div>
                </div>

                <!----------- country ---------------------------------->
                <div class="field">
                  <label class="label">Land</label>
                  <div class="control">
                    <input class="input" type="text" v-model="n.address.country" name="country">
                  </div>
                </div>

                <!----------- phone ---------------------------------->
                <div class="field">
                  <label class="label">Telefon</label>
                  <div class="control">
                    <input class="input" type="text" v-model="n.address.phone" name="phone">
                  </div>
                </div>

                <!----------- infos ---------------------------------->
                <div class="field">
                  <div class="control">
                    <label class="label">Informationen</label>
                    <textarea
                      class="textarea"
                      placeholder="Öfnungszeiten, Zusatzinformationen, ..."
                      rows="4"
                      v-model="n.address.infos"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>

            <!----------- videos ---------------------------------->
            <div class="column is-12">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <label class="label">Youtube Videos</label>
                    <div class="field has-addons">
                      <div class="control is-expanded">
                        <input class="input" v-model="video" placeholder="Youtube-Video ID">
                      </div>
                      <div class="control">
                        <a
                          class="button is-info"
                          :disabled="video == ''"
                          @click="addVideo"
                        >Hinzufügen</a>
                      </div>
                    </div>
                  </div>
                </div>

                <draggable
                  v-model="n.videos"
                  :options="{draggable:'.column'}"
                  class="columns is-multiline"
                >
                  <div class="column is-3" v-for="(i, index) in n.videos" :key="index">
                    <div class="card card-equal-height">
                      <header class="card-header">
                        <p class="card-header-title">Video</p>
                      </header>
                      <div class="card-image">
                        <div class="videowrapper" style="margin-top:0; margin-bottom:0;">
                          <iframe
                            width="100%"
                            height="auto"
                            :src="'https://www.youtube.com/embed/' + i"
                            frameborder="0"
                            allowfullscreen
                          ></iframe>
                        </div>
                        <footer class="card-footer">
                          <a class="card-footer-item" @click="deleteVideo(index)">Löschen</a>
                        </footer>
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <!----------- links ---------------------------------->
            <div class="column is-12">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <label class="label">Links</label>
                    <div class="field has-addons">
                      <div class="control">
                        <div class="select">
                          <select v-model="link.type">
                            <option value="www">WWW</option>
                            <option value="fb">Facebook</option>
                            <option value="ig">Instagram</option>
                            <option value="yt">YouTube</option>
                            <option value="li">LinkedIn</option>
                            <option value="xi">Xing</option>
                            <option value="tw">Twitter</option>
                            <option value="g+">Google+</option>
                          </select>
                        </div>
                      </div>
                      <div class="control has-icons-right is-expanded">
                        <input
                          class="input"
                          v-model="link.url"
                          name="linkurl"
                          v-validate="'url:require_protocol'"
                          placeholder="URL mit https://"
                        >
                        <span class="icon is-right" v-show="errors.has('linkurl')">
                          <i class="fa fa-warning"></i>
                        </span>
                        <span v-show="errors.has('linkurl')" class="help is-danger">URL ungültig</span>
                      </div>
                      <div class="control">
                        <a
                          class="button is-info"
                          :disabled="!link.url.length || errors.has('linkurl')"
                          @click="addLink"
                        >Hinzufügen</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="columns is-multiline">
                  <div class="column is-12" v-for="(i, index) in n.links" :key="index">
                    <a
                      class="delete is-pulled-left"
                      style="margin-right: 10px;"
                      @click="deleteLink(index)"
                    ></a>
                    {{ i.url }}
                  </div>
                </div>
              </div>
            </div>

            <!----------- images ---------------------------------->
            <div class="column is-12">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <strong>Fotos (Mindestbreite 1350px, Höhe variabel)</strong>
                    
                    <a
                      class="icon is-info is-large is-pulled-right"
                      @click="showImageSelector('fotos')"
                    >
                      <i class="fa fa-plus-circle fa-2x"></i>
                    </a>
                  </div>
                </div>

                <draggable
                  v-model="n.images"
                  :options="{draggable:'.column'}"
                  class="columns is-multiline"
                >
                  <div class="column is-3" v-for="(i, index) in n.images" :key="index">
                    <div class="card card-equal-height">
                      <div class="card-image">
                        <figure class="image">
                          <img :src="assetsBaseUrl + i.path">
                        </figure>
                      </div>
                      <div class="card-content">
                        <div class="content">
                          <textarea
                            rows="4"
                            class="textarea"
                            v-model="i.caption"
                            placeholder="Bildtext"
                          ></textarea>
                          <p>
                            <input
                              type="text"
                              class="input"
                              placeholder="Fotonachweis"
                              v-model="i.credits"
                            >
                          </p>
                        </div>
                      </div>
                      <footer class="card-footer">
                        <a class="card-footer-item" @click="deleteImg(index)">Löschen</a>
                      </footer>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>

            <!----------- image selector modal ---------------------------------->
            <div class="modal is-active" v-if="imgSelector">
              <div class="modal-background" @click="imgSelector=!imgSelector"></div>
              <div class="modal-card card-margin">
                <header class="modal-card-head">
                  <p class="modal-card-title">Bilder wählen</p>
                  <a class="delete" aria-label="close" @click="imgSelector=!imgSelector"></a>
                </header>
                <section class="modal-card-body">
                  <div class="columns is-multiline">
                    <div class="column is-12">
                      <div class="select is-fullwidth">
                        <select @change="getS3Files($event.target.value)">
                          <option value="root">/</option>
                          <option v-for="(i, index) in S3folders" :key="index" :value="i">{{ i }}</option>
                        </select>
                      </div>
                    </div>
                    <div class="column is-12">
                      <table
                        class="table is-bordered is-hoverable is-striped is-narrow is-fullwidth"
                      >
                        <thead>
                          <tr>
                            <th>
                              Dateiname
                              <a class="icon is-pulled-right" @click="showList=true">
                                <i class="fa fa-reorder"></i>
                              </a>
                              <a class="icon is-pulled-right" @click="showList=false">
                                <i class="fa fa-th-large"></i>
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="showList" v-for="(i, index) in S3files" :key="index">
                            <td>
                              <a @click="addImage(i, target)">{{ i }}</a>
                            </td>
                          </tr>
                          <tr v-if="!showList">
                            <td>
                              <div
                                class="columns is-variable is-multiline is-1 is-mobile"
                                v-masonry
                                transition-duration="0.3s"
                                item-selector=".bilder"
                              >
                                <div
                                  v-masonry-tile
                                  class="column is-3 bilder break-word"
                                  v-for="(i, index) in S3files"
                                  :key="index"
                                >
                                  <a @click="addImage(i, target)">
                                    <img :src="assetsBaseUrl + i">
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="!S3files.length">
                            <td>Dieser Ordner ist leer</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </section>
                <footer class="modal-card-foot">
                  <a class="button" @click="imgSelector=!imgSelector">Abbrechen</a>
                </footer>
              </div>
            </div>

            <!----------- imagepreview ---------------------------------->
            <div class="column is-4">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <strong>Übersichtsfoto (450 x 250 px)*</strong>
                    
                    <a
                      class="icon is-info is-large is-pulled-right"
                      @click="showImageSelector('imagePreview')"
                      v-if="!n.address.image.path"
                    >
                      <i class="fa fa-plus-circle fa-2x"></i>
                    </a>
                  </div>
                </div>

                <div class="columns is-multiline" v-if="n.address.image.path">
                  <div class="column is-12">
                    <div class="card card-equal-height">
                      <div class="card-image">
                        <figure class="image">
                          <img :src="assetsBaseUrl + n.address.image.path">
                        </figure>
                      </div>
                      <div class="card-content">
                        <div class="content">
                          <input
                            type="text"
                            class="input"
                            placeholder="Beschreibung / Fotonachweis"
                            v-model="n.address.image.credits"
                          >
                        </div>
                      </div>
                      <footer class="card-footer">
                        <a
                          class="card-footer-item"
                          @click="n.address.image={ path: '', credits: '' }"
                        >Löschen</a>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!----------- logo ---------------------------------->
            <div class="column is-4">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <strong>Logo</strong>
                    
                    <a
                      class="icon is-info is-large is-pulled-right"
                      @click="showImageSelector('logo')"
                      v-if="!n.logo"
                    >
                      <i class="fa fa-plus-circle fa-2x"></i>
                    </a>
                  </div>
                </div>

                <div class="columns is-multiline" v-if="n.logo">
                  <div class="column is-12">
                    <div class="card card-equal-height">
                      <div class="card-image">
                        <figure class="image">
                          <img :src="assetsBaseUrl + n.logo">
                        </figure>
                      </div>
                      <footer class="card-footer">
                        <a class="card-footer-item" @click="n.logo=''">Löschen</a>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!----------- adImage ---------------------------------->
            <div class="column is-4">
              <div class="box">
                <div class="columns">
                  <div class="column is-12">
                    <strong>Inserat</strong>
                    
                    <a
                      class="icon is-info is-large is-pulled-right"
                      @click="showImageSelector('adImage')"
                      v-if="!n.adImage"
                    >
                      <i class="fa fa-plus-circle fa-2x"></i>
                    </a>
                  </div>
                </div>

                <div class="columns is-multiline" v-if="n.adImage">
                  <div class="column is-12">
                    <div class="card card-equal-height">
                      <div class="card-image">
                        <figure class="image">
                          <img :src="assetsBaseUrl + n.adImage">
                        </figure>
                      </div>
                      <footer class="card-footer">
                        <a class="card-footer-item" @click="n.adImage=''">Löschen</a>
                      </footer>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="column is-12">
              <input
                type="submit"
                value="Speichern"
                class="button is-large is-primary is-fullwidth"
                :disabled="!n.address.image.path || !n.seo.description || !n.text"
              >
            </div>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import { VueEditor } from 'vue2-editor'
import flatPickr from 'vue-flatpickr-component'
import axios from 'axios'
import { VueMasonryPlugin } from 'vue-masonry'
import 'flatpickr/dist/flatpickr.css'
import draggable from 'vuedraggable'

Vue.use(VueMasonryPlugin)
Vue.use(VeeValidate)
export default {
  props: ['id'],
  data() {
    return {
      showList: true,
      S3folders: [],
      S3files: [],
      editMode: false,
      target: 'fotos',
      imgSelector: false,
      video: '',
      link: { type: 'www', url: '' },
      dateConfig: {
        dateFormat: 'd-m-Y',
        mode: 'range',
        minDate: 'today'
      },
      center: { lng: 15.5, lat: 48.5 },
      confirmed: false,
      isEmpty: 'Benötigtes Feld',
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ script: 'sub' }, { script: 'super' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote'],
        [{ header: [2, 3, 4, 5, 6, false] }],
        ['link'],
        ['clean']
      ],
      n: {
        active: true, // BOOLEAN
        type: 1, // required INT
        headline: '', // required VARCHAR
        subtitle: '', // VARCHAR
        text: '', // required TEXT
        ad: true, // required BOOLEAN
        adImage: '', // VARCHAR
        logo: '', // VARCHAR
        address: {
          // JSON
          name: '',
          street: '',
          zip: '',
          city: '',
          country: '',
          phone: '',
          position: {
            lng: undefined, // required
            lat: undefined // required
          },
          infos: '',
          image: { path: '', credits: '' }
        },
        date: '', // VARCHAR
        links: [], // JSON
        images: [], // JSON
        videos: [], // JSON
        tags: [], // required JSON
        seo: {
          // JSON
          can: '',
          niceUrl: '', // required
          description: '',
          title: '', // required
          ogType: 'article'
        }
      }
    }
  },
  metaInfo: {
    meta: [{ name: 'robots', content: 'NOINDEX, NOFOLLOW' }]
  },
  methods: {
    getS3Files(v) {
      const vm = this
      axios
        .get('/files/' + v)
        .then(function(res) {
          vm.S3files = res.data
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    getS3Folders() {
      const vm = this
      axios
        .get('/folders')
        .then(function(res) {
          vm.S3folders = res.data
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    // validation, check if edit mode is on, if new: check if niceUrl already exists, create or update
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (!this.editMode) {
            const vm = this
            axios
              .post('/content/checkUrl', this.n.seo)
              .then(function(response) {
                if (response.data === true) {
                  alert('Dieser Meta Title und URL sind schon in Verwendung!')
                } else {
                  axios
                    .post('/content', vm.n)
                    .then(function(response) {
                      vm.confirmed = true
                      // vm.SSRcontent(vm.n.seo.niceUrl)
                      vm.$router.push('/cms/list')
                    })
                    .catch(function(error) {
                      alert('Es ist leider ein Fehler aufgetreten!')
                      console.log(error)
                    })
                }
              })
              .catch(function(error) {
                alert('Es ist leider ein Fehler aufgetreten!')
                console.log(error)
              })
            return
          } else {
            const vm = this
            axios
              .put('/content/' + this.n.id, this.n)
              .then(function(response) {
                vm.confirmed = true
                // vm.SSRcontent(vm.n.seo.niceUrl)
                vm.$router.push('/cms/list')
              })
              .catch(function(error) {
                alert('Es ist leider ein Fehler aufgetreten!')
                console.log(error)
              })
            return
          }
        }
        alert('Bitte füllen Sie alle benötigten Felder aus!')
      })
    },
    showImageSelector(target) {
      this.imgSelector = true
      this.target = target
      if (!this.S3files.length) {
        this.getS3Files('root')
        this.getS3Folders()
      }
    },
    // SSRcontent(path) {
    //   const rtoken = localStorage.getItem('rtoken')
    //   const rid = localStorage.getItem('rid')
    //   if (rtoken && rid && path) {
    //     axios
    //       .put(
    //         'https://api.roast.io/api/v1/sites/' + rid + '/ssr',
    //         { paths: ['/details/' + path] },
    //         { headers: { Authorization: 'Bearer ' + rtoken } }
    //       )
    //       .then(function(response) {
    //         console.log('SSR success')
    //       })
    //       .catch(function(error) {
    //         console.log(error)
    //       })
    //   }
    // },
    getCoordinates(place) {
      const pos = {
        lat: Number(place.latLng.lat()),
        lng: Number(place.latLng.lng())
      }
      this.n.address.position = pos
      this.center = pos
    },
    deleteVideo(v) {
      this.n.videos.splice(v, 1)
    },
    addVideo() {
      this.n.videos.push(this.video)
      this.video = ''
    },
    addImage(path, target) {
      if (target === 'fotos') {
        const img = { path: path, caption: '', credits: '' }
        this.n.images.push(img)
      } else if (target === 'logo') {
        this.n.logo = path
      } else if (target === 'adImage') {
        this.n.adImage = path
      } else if (target === 'imagePreview') {
        this.n.address.image.path = path
      }
      this.imgSelector = false
    },
    deleteLink(v) {
      this.n.links.splice(v, 1)
    },
    deleteImg(v) {
      this.n.images.splice(v, 1)
    },
    addLink() {
      if (this.link.url.length && !this.$validator.errors.has('linkurl')) {
        this.n.links.push(this.link)
        this.link = { type: 'www', url: '' }
      }
    },
    filterContentBy(v) {
      var i = this.n.tags.indexOf(v)
      if (i === -1) {
        this.n.tags.push(v)
      } else {
        this.n.tags.splice(i, 1)
      }
    },
    setPlace(place) {
      if (place.address_components !== undefined) {
        let addressComponents = {
          street_number: 'long_name',
          route: 'long_name',
          locality: 'long_name',
          administrative_area_level_1: 'long_name',
          country: 'long_name',
          postal_code: 'long_name'
        }
        // Get each component of the address from the place details
        for (let i = 0; i < place.address_components.length; i++) {
          let addressType = place.address_components[i].types[0]
          if (addressComponents[addressType]) {
            let val =
              place.address_components[i][addressComponents[addressType]]
            addressComponents[addressType] = val
          }
        }
        this.n.address.position.lat = place.geometry.location.lat()
        this.n.address.position.lng = place.geometry.location.lng()
        this.center.lat = place.geometry.location.lat()
        this.center.lng = place.geometry.location.lng()
        if (addressComponents.route !== 'long_name') {
          this.n.address.street = addressComponents.route
        }
        if (addressComponents.street_number !== 'long_name') {
          this.n.address.street =
            this.n.address.street + ' ' + addressComponents.street_number
        }
        if (addressComponents.postal_code !== 'long_name') {
          this.n.address.zip = addressComponents.postal_code
        }
        if (addressComponents.country !== 'long_name') {
          this.n.address.country = addressComponents.country
        }
        if (addressComponents.locality !== 'long_name') {
          this.n.address.city = addressComponents.locality
        }
        if (place.international_phone_number) {
          this.n.address.phone = place.international_phone_number
        }
        if (place.name) {
          this.n.address.name = place.name
        }
      }
    },
    sanitizeTitle() {
      if (!this.editMode) {
        var slug = this.n.seo.title
        slug = slug.toLowerCase()
        // Umlaut ä
        slug = slug.replace(/ä/gi, 'ae')
        // Umlaut ö
        slug = slug.replace(/ö/gi, 'oe')
        // Umlaut ü
        slug = slug.replace(/ü/gi, 'ue')
        // ß
        slug = slug.replace(/ß/gi, 'ss')
        // Trim the last whitespace
        slug = slug.replace(/\s*$/g, '')
        // Change whitespace to "-"
        slug = slug.replace(/\s+/g, '-')
        // special characters
        slug = slug.replace(/[^a-zA-Z0-9-]/g, '')
        this.n.seo.niceUrl = slug
      }
    }
  },
  computed: {
    allTags() {
      return this.$store.getters.allTags
    },
    assetsBaseUrl() {
      return this.$store.getters.assetsBaseUrl
    }
  },
  created() {
    // if edit mode is on, fetch and replace n with the corresponding object
    if (this.$route.name === 'edit') {
      this.editMode = true
      const vm = this
      axios
        .get('/content/single/' + this.id)
        .then(function(res) {
          vm.n = res.data
        })
        .catch(function(error) {
          console.log(error)
        })
    }
  },
  components: {
    VueEditor,
    flatPickr,
    draggable
  },
  beforeRouteLeave(to, from, next) {
    if (this.confirmed) {
      next()
    } else {
      if (
        confirm(
          'Der Datensatz wurde noch nicht gespeichert. Wollen Sie die Seite wirklich verlassen?'
        )
      ) {
        next()
      } else {
        next(false)
      }
    }
  }
}
</script>

<style scoped>
.card-content {
  padding: 0;
}
.bilder {
  width: 28%;
  height: auto;
  margin: 6px;
}
</style>
